import { ReactNode, createContext, useContext, useState } from 'react';
import { useCreatePosMutation } from '../pos.mutations';
import { AutocompletePointOfSaleType, PosContextProps, StorePosStatusType } from '../pos.types';

type PosContextProviderProps = {
  children: ReactNode;
};

export const PosContext = createContext<PosContextProps>({
  isPosOpen: true,
  isSubmitting: false,
  handleAnswerLater: () => undefined,
  handleAnswerOk: () => undefined,
  onClose: () => undefined,
});

export const PosContextProvider = ({ children }: PosContextProviderProps) => {
  const [isPosOpen, setIsPosOpen] = useState(true);

  const onClose = () => setIsPosOpen(false);

  const { createPos, isPending } = useCreatePosMutation();

  const handleAnswerLater = () => {
    if (isPending) {
      return;
    }
    createPos({ status: StorePosStatusType.LATER }, { onSettled: onClose });
  };

  const handleAnswerOk = (pointOfSale: AutocompletePointOfSaleType | undefined) => {
    if (isPending) {
      return;
    }
    createPos({ status: StorePosStatusType.OK, pointOfSale }, { onSuccess: onClose });
  };

  const values: PosContextProps = {
    isPosOpen,
    isSubmitting: isPending,
    handleAnswerLater,
    handleAnswerOk,
    onClose,
  };

  return <PosContext.Provider value={values}>{children}</PosContext.Provider>;
};

export const usePosContext = () => useContext<PosContextProps>(PosContext);
